export default {
  name: 'Company',
  props: [
    'address',
    'contact',
    'name',
    'primaryColor',
    'url',
    'lang'
  ],
  data () {
    return {
      term: ''
    }
  },
  methods: {
    translateTermsOfService () {
      if (this.lang === 'zh-TW') {
        this.term = '服務條款'
      } else {
        this.term = 'Terms of Service'
      }
    }
  },
  updated () {
    this.translateTermsOfService()
  }
}



// WEBPACK FOOTER //
// ./src/assets/pages/Company/Company.js